/**
 * @file grid-layout 布局定义
 * @description 现货、合约、简易合约
 */
import { Layout as LayoutType } from '@/plugins/grid-layout/types';

// 永续合约
export const GRID_LAYOUT_FUTURE = <Record<string, LayoutType>>{
  2200: [
    { i: 'notice', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-favorite', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-bar', x: 0, y: 0, h: 32, w: 16, minW: 8, minH: 32, maxH: 32, isDraggable: false, isCloseable: false, visible: true },
    { i: 'chart', x: 0, y: 33, h: 309, w: 16, minW: 8, minH: 100, visible: true },
    { i: 'orderbook&trades', x: 16, y: 0, h: 341, w: 4, minW: 3, minH: 20, visible: true },
    { i: 'place-order', x: 20, y: 0, h: 341, w: 4, minW: 4, minH: 20, visible: true },
    { i: 'order-list', x: 0, y: 341, h: 186, w: 20, minW: 8, minH: 18, visible: true },
    { i: 'assets', x: 20, y: 341, h: 186, w: 4, minW: 3, minH: 20, visible: true }
  ],
  1920: [
    { i: 'notice', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-favorite', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-bar', x: 0, y: 0, h: 32, w: 16, minW: 8, minH: 32, maxH: 32, isDraggable: false, isCloseable: false, visible: true },
    { i: 'chart', x: 0, y: 33, h: 250, w: 16, minW: 8, minH: 100, visible: true },
    { i: 'orderbook&trades', x: 16, y: 0, h: 282, w: 4, minW: 3, minH: 20, visible: true },
    { i: 'place-order', x: 20, y: 0, h: 282, w: 4, minW: 4, minH: 20, visible: true },
    { i: 'order-list', x: 0, y: 283, h: 186, w: 20, minW: 8, minH: 18, visible: true },
    { i: 'assets', x: 20, y: 283, h: 186, w: 4, minW: 3, minH: 20, visible: true }
  ],
  1440: [
    { i: 'notice', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-favorite', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-bar', x: 0, y: 0, h: 32, w: 19, minW: 8, minH: 32, maxH: 32, isDraggable: false, isCloseable: false, visible: true },
    { i: 'chart', x: 0, y: 33, h: 250, w: 14, minW: 8, minH: 100, visible: true },
    { i: 'orderbook&trades', x: 14, y: 33, h: 250, w: 5, minW: 3, minH: 20, visible: true },
    { i: 'place-order', x: 19, y: 0, h: 282, w: 5, minW: 5, minH: 20, visible: true },
    { i: 'order-list', x: 0, y: 283, h: 186, w: 19, minW: 8, minH: 18, visible: true },
    { i: 'assets', x: 19, y: 283, h: 186, w: 5, minW: 3, minH: 20, visible: true }
  ],
  1200: [
    { i: 'notice', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-favorite', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-bar', x: 0, y: 0, h: 32, w: 18, minW: 8, minH: 32, maxH: 32, isDraggable: false, isCloseable: false, visible: true },
    { i: 'chart', x: 0, y: 33, h: 250, w: 13, minW: 8, minH: 100, visible: true },
    { i: 'orderbook&trades', x: 13, y: 33, h: 250, w: 5, minW: 3, minH: 20, visible: true },
    { i: 'place-order', x: 18, y: 0, h: 282, w: 6, minW: 5, minH: 20, visible: true },
    { i: 'order-list', x: 0, y: 283, h: 186, w: 18, minW: 8, minH: 18, visible: true },
    { i: 'assets', x: 18, y: 283, h: 186, w: 6, minW: 3, minH: 20, visible: true }
  ],
  1024: [
    { i: 'notice', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-favorite', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-bar', x: 0, y: 0, h: 32, w: 24, minW: 8, minH: 32, maxH: 32, isDraggable: false, isCloseable: false, visible: true },
    { i: 'chart', x: 0, y: 33, h: 224, w: 16, minW: 8, minH: 100, visible: true },
    { i: 'trades', x: 0, y: 256, h: 207, w: 8, minW: 3, minH: 20, visible: true },
    { i: 'orderbook', x: 8, y: 256, h: 207, w: 8, minW: 3, minH: 20, visible: true },
    { i: 'place-order', x: 16, y: 0, h: 431, w: 8, minW: 8, minH: 20, visible: true },
    { i: 'order-list', x: 0, y: 462, h: 210, w: 16, minW: 8, minH: 18, visible: true },
    { i: 'assets', x: 16, y: 463, h: 210, w: 8, minW: 3, minH: 20, visible: true }
  ]
};

// 简易合约
export const GRID_LAYOUT_LITE_PERPETUAL = <Record<string, LayoutType>>{
  2200: [
    { i: 'notice', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-favorite', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-bar', x: 0, y: 0, h: 32, w: 16, minW: 8, minH: 32, maxH: 32, isDraggable: false, isCloseable: false, visible: true },
    { i: 'chart', x: 0, y: 33, h: 309, w: 16, minW: 8, minH: 100, visible: true },
    { i: 'orderbook&trades', x: 16, y: 0, h: 341, w: 4, minW: 3, minH: 20, visible: true },
    { i: 'place-order', x: 20, y: 0, h: 570, w: 4, minW: 4, minH: 20, visible: true },
    { i: 'order-list', x: 0, y: 384, h: 186, w: 20, minW: 8, minH: 18, visible: true },
    { i: 'assets', x: 0, y: 341, h: 43, w: 20, minW: 8, minH: 43, visible: true }
  ],
  1920: [
    { i: 'notice', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-favorite', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-bar', x: 0, y: 0, h: 32, w: 16, minW: 8, minH: 32, maxH: 32, isDraggable: false, isCloseable: false, visible: true },
    { i: 'chart', x: 0, y: 33, h: 250, w: 16, minW: 8, minH: 100, visible: true },
    { i: 'orderbook&trades', x: 16, y: 0, h: 282, w: 4, minW: 3, minH: 20, visible: true },
    { i: 'place-order', x: 20, y: 0, h: 511, w: 4, minW: 4, minH: 20, visible: true },
    { i: 'order-list', x: 0, y: 326, h: 186, w: 20, minW: 8, minH: 18, visible: true },
    { i: 'assets', x: 0, y: 283, h: 43, w: 20, minW: 8, minH: 43, visible: true }
  ],
  1440: [
    { i: 'notice', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-favorite', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-bar', x: 0, y: 0, h: 32, w: 19, minW: 8, minH: 32, maxH: 32, isDraggable: false, isCloseable: false, visible: true },
    { i: 'chart', x: 0, y: 33, h: 250, w: 14, minW: 8, minH: 100, visible: true },
    { i: 'orderbook&trades', x: 14, y: 33, h: 250, w: 5, minW: 3, minH: 20, visible: true },
    { i: 'place-order', x: 19, y: 0, h: 512, w: 5, minW: 5, minH: 20, visible: true },
    { i: 'order-list', x: 0, y: 326, h: 186, w: 19, minW: 8, minH: 18, visible: true },
    { i: 'assets', x: 0, y: 283, h: 43, w: 19, minW: 8, minH: 43, visible: true }
  ],
  1200: [
    { i: 'notice', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-favorite', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-bar', x: 0, y: 0, h: 32, w: 18, minW: 8, minH: 32, maxH: 32, isDraggable: false, isCloseable: false, visible: true },
    { i: 'chart', x: 0, y: 33, h: 250, w: 13, minW: 8, minH: 100, visible: true },
    { i: 'orderbook&trades', x: 13, y: 33, h: 250, w: 5, minW: 3, minH: 20, visible: true },
    { i: 'place-order', x: 18, y: 0, h: 512, w: 6, minW: 5, minH: 20, visible: true },
    { i: 'order-list', x: 0, y: 326, h: 186, w: 18, minW: 8, minH: 18, visible: true },
    { i: 'assets', x: 0, y: 283, h: 43, w: 18, minW: 8, minH: 43, visible: true }
  ],
  1024: [
    { i: 'notice', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-favorite', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-bar', x: 0, y: 0, h: 32, w: 24, minW: 8, minH: 32, maxH: 32, isDraggable: false, isCloseable: false, visible: true },
    { i: 'chart', x: 0, y: 33, h: 224, w: 16, minW: 8, minH: 100, visible: true },
    { i: 'trades', x: 0, y: 256, h: 207, w: 8, minW: 3, minH: 20, visible: true },
    { i: 'orderbook', x: 8, y: 256, h: 207, w: 8, minW: 3, minH: 20, visible: true },
    { i: 'place-order', x: 16, y: 0, h: 431, w: 8, minW: 8, minH: 20, visible: true },
    { i: 'order-list', x: 0, y: 505, h: 210, w: 24, minW: 8, minH: 18, visible: true },
    { i: 'assets', x: 0, y: 462, h: 43, w: 24, minW: 8, minH: 43, visible: true }
  ]
};

// 现货
export const GRID_LAYOUT_SPOT = <Record<string, LayoutType>>{
  1920: [
    { i: 'notice', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-favorite', x: 4, y: 0, h: 20, w: 20, minW: 20, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'symbols', x: 0, y: 0, h: 447, w: 4, minW: 2, minH: 100, isDraggable: true, isCloseable: false, visible: true },
    { i: 'tick-bar', x: 4, y: 0, h: 32, w: 20, minW: 20, minH: 32, maxH: 32, isDraggable: true, isCloseable: false, visible: true },
    { i: 'chart', x: 4, y: 32, h: 224, w: 12, minW: 4, minH: 100, visible: true },
    { i: 'place-order', x: 4, y: 256, h: 171, w: 12, minW: 4, minH: 100,  visible: true },
    { i: 'orderbook', x: 16, y: 0, h: 395, w: 4, minW: 3, minH: 100, visible: true },
    { i: 'trades', x: 20, y: 0, h: 395, w: 4, minW: 3, minH: 100,  visible: true },
    { i: 'order', x: 0, y: 427, h: 207, w: 24, minW: 8, minH: 50, visible: true }
  ],
  1600: [
    { i: 'notice', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-favorite', x: 5, y: 0, h: 20, w: 19, minW: 19, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'symbols', x: 0, y: 0, h: 447, w: 5, minW: 2, minH: 100, isDraggable: true, isCloseable: false, visible: true },
    { i: 'tick-bar', x: 5, y: 0, h: 32, w: 19, minW: 12, minH: 32, maxH: 32, isDraggable: true, isCloseable: false, visible: true },
    { i: 'chart', x: 5, y: 32, h: 224, w: 14, minW: 4, minH: 100, visible: true },
    { i: 'place-order', x: 5, y: 256, h: 171, w: 14, minW: 4, minH: 100, visible: true },
    { i: 'orderbook', x: 19, y: 0, h: 195, w: 5, minW: 3, minH: 100, visible: true },
    { i: 'trades', x: 19, y: 186, h: 200, w: 5, minW: 3, minH: 100, visible: true },
    { i: 'order', x: 0, y: 427, h: 207, w: 24, minW: 12, minH: 50, visible: true }
  ],
  1440: [
    { i: 'notice', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-favorite', x: 6, y: 0, h: 20, w: 18, minW: 18, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'symbols', x: 0, y: 0, h: 447, w: 6, minW: 2, minH: 100, isDraggable: true, isCloseable: false, visible: true },
    { i: 'tick-bar', x: 6, y: 0, h: 32, w: 18, minW: 12, minH: 32, maxH: 32, isDraggable: true, isCloseable: false, visible: true },
    { i: 'chart', x: 6, y: 32, h: 224, w: 13, minW: 4, minH: 100, visible: true },
    { i: 'place-order', x: 6, y: 256, h: 171, w: 13, minW: 4, minH: 100, visible: true },
    { i: 'orderbook', x: 19, y: 0, h: 195, w: 5, minW: 3, minH: 100, visible: true },
    { i: 'trades', x: 19, y: 186, h: 200, w: 5, minW: 3, minH: 100, visible: true },
    { i: 'order', x: 0, y: 427, h: 207, w: 24, minW: 12, minH: 50, visible: true }
  ],
  1200: [
    { i: 'notice', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-favorite', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'symbols', x: 0, y: 0, h: 447, w: 4, minW: 2, minH: 100, isDraggable: true, isCloseable: false, visible: false },
    { i: 'tick-bar', x: 0, y: 0, h: 32, w: 24, minW: 22, minH: 32, maxH: 32, isDraggable: false, isCloseable: false, visible: true },
    { i: 'chart', x: 0, y: 32, h: 224, w: 18, minW: 4, minH: 100,  visible: true },
    { i: 'place-order', x: 0, y: 256, h: 171, w: 18, minW: 4, minH: 100, visible: true },
    { i: 'orderbook', x: 18, y: 0, h: 195, w: 6, minW: 3, minH: 100, visible: true },
    { i: 'trades', x: 18, y: 186, h: 200, w: 6, minW: 3, minH: 100, visible: true },
    { i: 'order', x: 0, y: 427, h: 207, w: 24, minW: 12, minH: 50, visible: true }
  ],
  1024: [
    { i: 'notice', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-favorite', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'symbols', x: 0, y: 0, h: 447, w: 4, minW: 2, minH: 100, isDraggable: true, isCloseable: false, visible: false },
    { i: 'tick-bar', x: 0, y: 0, h: 32, w: 24, minW: 22, minH: 32, maxH: 32, isDraggable: false, isCloseable: false, visible: true },
    { i: 'chart', x: 0, y: 32, h: 224, w: 16, minW: 4, minH: 100,  visible: true },
    { i: 'place-order', x: 0, y: 256, h: 171, w: 16, minW: 4, minH: 100, visible: true },
    { i: 'orderbook', x: 16, y: 0, h: 195, w: 8, minW: 3, minH: 100, visible: true },
    { i: 'trades', x: 16, y: 186, h: 200, w: 8, minW: 3, minH: 100, visible: true },
    { i: 'order', x: 0, y: 427, h: 207, w: 24, minW: 12, minH: 50, visible: true }
  ]
};

// 模拟合约交易
export const GRID_LAYOUT_DEMO_FUTURE = <Record<string, LayoutType>>{
  2200: [
    { i: 'notice', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-favorite', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-bar', x: 0, y: 0, h: 32, w: 16, minW: 8, minH: 32, maxH: 32, isDraggable: false, isCloseable: false, visible: true },
    { i: 'chart', x: 0, y: 33, h: 309, w: 16, minW: 8, minH: 100, visible: true },
    { i: 'orderbook&trades', x: 16, y: 0, h: 341, w: 4, minW: 3, minH: 20, visible: true },
    { i: 'place-order', x: 20, y: 0, h: 341, w: 4, minW: 4, minH: 20, visible: true },
    { i: 'order-list', x: 0, y: 341, h: 186, w: 20, minW: 8, minH: 18, visible: true },
    { i: 'assets', x: 20, y: 341, h: 186, w: 4, minW: 3, minH: 20, visible: true }
  ],
  1920: [
    { i: 'notice', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-favorite', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-bar', x: 0, y: 0, h: 32, w: 16, minW: 8, minH: 32, maxH: 32, isDraggable: false, isCloseable: false, visible: true },
    { i: 'chart', x: 0, y: 33, h: 250, w: 16, minW: 8, minH: 100, visible: true },
    { i: 'orderbook&trades', x: 16, y: 0, h: 282, w: 4, minW: 3, minH: 20, visible: true },
    { i: 'place-order', x: 20, y: 0, h: 282, w: 4, minW: 4, minH: 20, visible: true },
    { i: 'order-list', x: 0, y: 283, h: 186, w: 20, minW: 8, minH: 18, visible: true },
    { i: 'assets', x: 20, y: 283, h: 186, w: 4, minW: 3, minH: 20, visible: true }
  ],
  1440: [
    { i: 'notice', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-favorite', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-bar', x: 0, y: 0, h: 32, w: 19, minW: 8, minH: 32, maxH: 32, isDraggable: false, isCloseable: false, visible: true },
    { i: 'chart', x: 0, y: 33, h: 250, w: 14, minW: 8, minH: 100, visible: true },
    { i: 'orderbook&trades', x: 14, y: 33, h: 250, w: 5, minW: 3, minH: 20, visible: true },
    { i: 'place-order', x: 19, y: 0, h: 282, w: 5, minW: 5, minH: 20, visible: true },
    { i: 'order-list', x: 0, y: 283, h: 186, w: 19, minW: 8, minH: 18, visible: true },
    { i: 'assets', x: 19, y: 283, h: 186, w: 5, minW: 3, minH: 20, visible: true }
  ],
  1200: [
    { i: 'notice', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-favorite', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-bar', x: 0, y: 0, h: 32, w: 18, minW: 8, minH: 32, maxH: 32, isDraggable: false, isCloseable: false, visible: true },
    { i: 'chart', x: 0, y: 33, h: 250, w: 13, minW: 8, minH: 100, visible: true },
    { i: 'orderbook&trades', x: 13, y: 33, h: 250, w: 5, minW: 3, minH: 20, visible: true },
    { i: 'place-order', x: 18, y: 0, h: 282, w: 6, minW: 5, minH: 20, visible: true },
    { i: 'order-list', x: 0, y: 283, h: 186, w: 18, minW: 8, minH: 18, visible: true },
    { i: 'assets', x: 18, y: 283, h: 186, w: 6, minW: 3, minH: 20, visible: true }
  ],
  1024: [
    { i: 'notice', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-favorite', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-bar', x: 0, y: 0, h: 32, w: 24, minW: 8, minH: 32, maxH: 32, isDraggable: false, isCloseable: false, visible: true },
    { i: 'chart', x: 0, y: 33, h: 224, w: 16, minW: 8, minH: 100, visible: true },
    { i: 'trades', x: 0, y: 256, h: 207, w: 8, minW: 3, minH: 20, visible: true },
    { i: 'orderbook', x: 8, y: 256, h: 207, w: 8, minW: 3, minH: 20, visible: true },
    { i: 'place-order', x: 16, y: 0, h: 431, w: 8, minW: 8, minH: 20, visible: true },
    { i: 'order-list', x: 0, y: 462, h: 210, w: 16, minW: 8, minH: 18, visible: true },
    { i: 'assets', x: 16, y: 463, h: 210, w: 8, minW: 3, minH: 20, visible: true }
  ]
};

// 合约策略交易
export const GRID_LAYOUT_FUTURE_STRATEGY = <Record<string, LayoutType>>{
  2200: [
    { i: 'notice', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-favorite', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-bar', x: 0, y: 0, h: 32, w: 15, minW: 8, minH: 32, maxH: 32, isDraggable: false, isCloseable: false, visible: true },
    { i: 'chart', x: 0, y: 33, h: 309, w: 15, minW: 8, minH: 100, visible: true },
    { i: 'orderbook&trades', x: 15, y: 0, h: 341, w: 4, minW: 3, minH: 20, visible: true },
    { i: 'place-order', x: 19, y: 0, h: 527, w: 5, minW: 4, minH: 20, visible: true },
    { i: 'order-list', x: 0, y: 341, h: 186, w: 19, minW: 8, minH: 18, visible: true }
  ],
  1920: [
    { i: 'notice', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-favorite', x: 0, y: 0, h: 19, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-bar', x: 0, y: 0, h: 32, w: 15, minW: 8, minH: 32, maxH: 32, isDraggable: false, isCloseable: false, visible: true },
    { i: 'chart', x: 0, y: 33, h: 250, w: 15, minW: 8, minH: 100, visible: true },
    { i: 'orderbook&trades', x: 15, y: 0, h: 282, w: 4, minW: 3, minH: 20, visible: true },
    { i: 'place-order', x: 19, y: 0, h: 468, w: 5, minW: 4, minH: 20, visible: true },
    { i: 'order-list', x: 0, y: 283, h: 186, w: 19, minW: 8, minH: 18, visible: true }
  ],
  1440: [
    { i: 'notice', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-favorite', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-bar', x: 0, y: 0, h: 32, w: 19, minW: 8, minH: 32, maxH: 32, isDraggable: false, isCloseable: false, visible: true },
    { i: 'chart', x: 0, y: 33, h: 250, w: 14, minW: 8, minH: 100, visible: true },
    { i: 'orderbook&trades', x: 14, y: 33, h: 250, w: 5, minW: 3, minH: 20, visible: true },
    { i: 'place-order', x: 19, y: 0, h: 468, w: 5, minW: 5, minH: 20, visible: true },
    { i: 'order-list', x: 0, y: 283, h: 186, w: 19, minW: 8, minH: 18, visible: true }
  ],
  1200: [
    { i: 'notice', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-favorite', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-bar', x: 0, y: 0, h: 32, w: 18, minW: 8, minH: 32, maxH: 32, isDraggable: false, isCloseable: false, visible: true },
    { i: 'chart', x: 0, y: 33, h: 250, w: 13, minW: 8, minH: 100, visible: true },
    { i: 'orderbook&trades', x: 13, y: 33, h: 250, w: 5, minW: 3, minH: 20, visible: true },
    { i: 'place-order', x: 18, y: 0, h: 468, w: 6, minW: 5, minH: 20, visible: true },
    { i: 'order-list', x: 0, y: 283, h: 186, w: 18, minW: 8, minH: 18, visible: true }
  ],
  1024: [
    { i: 'notice', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-favorite', x: 0, y: 0, h: 20, w: 24, minW: 24, minH: 20, maxH: 20, isDraggable: false, isCloseable: false, visible: true },
    { i: 'tick-bar', x: 0, y: 0, h: 32, w: 24, minW: 8, minH: 32, maxH: 32, isDraggable: false, isCloseable: false, visible: true },
    { i: 'chart', x: 0, y: 33, h: 224, w: 16, minW: 8, minH: 100, visible: true },
    { i: 'trades', x: 0, y: 256, h: 207, w: 8, minW: 3, minH: 20, visible: true },
    { i: 'orderbook', x: 8, y: 256, h: 207, w: 8, minW: 3, minH: 20, visible: true },
    { i: 'place-order', x: 16, y: 0, h: 431, w: 8, minW: 8, minH: 20, visible: true },
    { i: 'order-list', x: 0, y: 462, h: 210, w: 24, minW: 8, minH: 18, visible: true }
  ]
};
